import React from 'react';
import { FadeIn } from './FadeIn';
const facts = [{
  label: 'Pioneros',
  value: 'Primera jurisdicción en reconocer la LLC en 1977.'
}, {
  label: 'Privacidad',
  value: 'Marco regulatorio que protege la identidad corporativa.'
}, {
  label: 'Estabilidad',
  value: 'Sistema legal predecible y favorable para negocios digitales.'
}, {
  label: 'Eficiencia',
  value: 'Estructura fiscal optimizada sin impuestos estatales corporativos.'
}];
export function Jurisdiction() {
  return <section id="jurisdiccion" className="py-32 md:py-48 px-6 md:px-12 bg-navy" data-id="element-74">
      <div className="max-w-7xl mx-auto" data-id="element-75">
        <FadeIn data-id="element-76">
          <span className="text-[11px] font-semibold tracking-[0.2em] uppercase text-muted mb-16 block text-center md:text-left" data-id="element-77">
            04 — Jurisdicción
          </span>
        </FadeIn>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center" data-id="element-78">
          <div data-id="element-79">
            <FadeIn delay={0.1} data-id="element-80">
              <h2 className="font-display text-4xl md:text-5xl text-cream leading-[1.05] mb-8" data-id="element-81">
                Constituida en Wyoming
              </h2>
              <p className="text-muted font-light text-lg leading-relaxed mb-8" data-id="element-82">
                Elegimos Wyoming como nuestra sede corporativa por una razón
                estratégica: es una de las jurisdicciones más respetadas y
                estables del mundo para empresas digitales modernas. Su
                tradición legal, privacidad y marco fiscal nos permiten operar
                con seguridad y eficiencia.
              </p>
              <p className="text-muted font-light text-lg leading-relaxed" data-id="element-83">
                Como el estado que inventó la estructura de la Sociedad de
                Responsabilidad Limitada (LLC), Wyoming ofrece la madurez
                jurídica que un negocio 100% online necesita para escalar
                globalmente sin fricciones.
              </p>
            </FadeIn>
          </div>

          <div className="bg-navy-panel p-8 md:p-12 border border-steel relative overflow-hidden" data-id="element-84">
            <div className="absolute -top-24 -right-24 w-64 h-64 border border-steel/30 rounded-full opacity-50 pointer-events-none" data-id="element-85"></div>

            <div className="relative z-10 space-y-8" data-id="element-86">
              {facts.map((fact, index) => <FadeIn key={fact.label} delay={0.2 + index * 0.1} data-id="element-87">
                  <div className="flex flex-col space-y-2" data-id="element-88">
                    <span className="text-[11px] font-semibold tracking-[0.15em] uppercase text-gold" data-id="element-89">
                      {fact.label}
                    </span>
                    <span className="text-cream font-light" data-id="element-90">{fact.value}</span>
                  </div>
                  {index !== facts.length - 1 && <div className="w-full h-[1px] bg-steel/50 mt-8" data-id="element-91"></div>}
                </FadeIn>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}